import { Link, useLocation } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { getBlogCategoryLabel } from '@/data/blog-taxonomy'
import { getPublicFeaturedBlogPosts } from '@/lib/blog/server'

export function MarketingDiscoveryStrip() {
  const { pathname } = useLocation()
  const featuredPosts = getPublicFeaturedBlogPosts(3)

  if (pathname === '/resources' || pathname === '/blog' || pathname.startsWith('/blog/')) {
    return null
  }

  return (
    <section className="marketing-shell py-16">
      <div className="grid gap-8 rounded-[24px] border border-line bg-[linear-gradient(135deg,#FFFFFF,#F5FBFF)] p-7 shadow-[0_18px_60px_rgba(15,35,78,0.06)] lg:grid-cols-[0.8fr_1.2fr] lg:p-8">
        <div className="space-y-4">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand">Resources</p>
          <h2 className="max-w-md text-3xl font-semibold leading-[1.12] text-ink">
            Keep your next decision simple.
          </h2>
          <Button asChild variant="secondary">
            <Link to="/resources">
              View resources
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {featuredPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="rounded-[18px] border border-line bg-white p-5 transition hover:-translate-y-1 hover:shadow-soft"
            >
              <p className="text-xs font-semibold text-brand">{getBlogCategoryLabel(post.category)}</p>
              <h3 className="mt-4 text-base font-semibold leading-6 text-ink">{post.title}</h3>
              <p className="mt-3 line-clamp-2 text-sm leading-6 text-ink-soft">{post.excerpt}</p>
              <p className="mt-4 text-xs text-ink-muted">By {post.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
